/* ==========================================================================
   VulkanUS · Farbfelder (Swatches) auf der Produktseite
   Shop-Check 16.09.2026, Punkt 13.

   Die Produktseite (sections/vk-pdp-buy.liquid) rendert die Variantenauswahl als
   schlichtes <select name="id" class="vk-varsel">. Dieses Skript baut daraus eine
   Reihe Farbfelder und blendet das <select> nur aus — es bleibt im Formular und
   behaelt name="id", der Warenkorb bekommt also unveraendert dieselbe Varianten-ID.
   Faellt das Skript aus, steht wieder das funktionierende Dropdown da.

   ---------------------------------------------------------------------------
   FARBWERTE — bitte hier pflegen.

   Shopify kennt zu diesen Optionswerten KEINE Farbe: die Produktoption „Farbe“
   ist eine reine Textoption, swatch ist bei jedem Wert null, und im Shop ist kein
   Farb-Metaobjekt angelegt. Solange das so bleibt, gibt es keine Farbe aus dem
   Shop zu lesen — die Werte unten sind die Quelle.

   Herkunft der Werte (Stand 16.09.2026, siehe
   Marketing/Shop-Redesign/_shopcheck_2026-09-16/fuer-Vic/13_Farbfelder_Farbwerte.md):
     schwarz   — aus dem Produktfoto vg2-classic.png gemessen (Gehaeuseflanken
                 #4E4E4E bis #303030 unter Studiolicht); hier der mittlere Ton.
     die uebrigen — aus dem Farbnamen abgeleitet, NICHT am Geraet geprueft.
                 Es gibt im Shop kein Foto der farbigen Varianten.
     PAUL/VIC: bitte gegen ein echtes Geraet gegenpruefen und hier korrigieren.
   ========================================================================== */
(function () {
  'use strict';

  var FARBEN = {
    'schwarz':       '#35373A',
    'signal orange': '#D4652F',
    'navy blue':     '#1F3855',
    'dusty lilac':   '#A597B0',
    'taupe':         '#8A8078',
    'deep moss':     '#4A5A3C',
    'chrom':         '#C9CDD2',
    /* Camouflage ist ein Muster, keine einzelne Farbe. Bis ein Musterbild
       hinterlegt ist, zeigen wir die drei Tarntoene als Streifen — das liest
       sich als Tarnmuster und nicht als beliebiges Gruen. */
    'camouflage':    'repeating-linear-gradient(125deg,#6E6B4B 0 34%,#3F4429 34% 62%,#8A7F63 62% 100%)'
  };

  function hintergrund(wert) {
    return wert.indexOf('gradient') === 0 ? wert : wert;
  }

  /* „Schwarz / Chrom“ → zweigeteiltes Feld. Der Crown besteht wirklich aus zwei
     Materialien; ein einzelner Farbfleck wuerde das falsch darstellen. */
  function ausLabel(label) {
    var teile = label.split('/').map(function (t) { return t.trim().toLowerCase(); });
    var werte = teile.map(function (t) { return FARBEN[t]; });
    if (werte.some(function (w) { return !w; })) return null;
    if (werte.length === 1) return hintergrund(werte[0]);
    if (werte.length === 2 && werte[0].indexOf('gradient') === -1 && werte[1].indexOf('gradient') === -1) {
      return 'linear-gradient(135deg,' + werte[0] + ' 0 50%,' + werte[1] + ' 50% 100%)';
    }
    return hintergrund(werte[0]);
  }

  function aufbauen(select) {
    var optionen = Array.prototype.slice.call(select.options);
    if (optionen.length < 2) return;

    /* Erst pruefen, ob JEDE Option eine hinterlegte Farbe hat. Wenn auch nur eine
       fehlt, bleibt das Dropdown stehen — lieber ein graues Menue als eine Reihe
       mit einem leeren Feld darin. */
    var farben = optionen.map(function (o) { return ausLabel(o.textContent.split('—')[0].trim()); });
    if (farben.some(function (f) { return !f; })) return;

    var gruppe = document.createElement('fieldset');
    gruppe.className = 'vk-sw';

    var kopf = document.createElement('legend');
    kopf.className = 'vk-sw__head';
    var lbl = document.createElement('span');
    lbl.className = 'vk-sw__lbl';
    lbl.textContent = 'Farbe';
    var val = document.createElement('span');
    val.className = 'vk-sw__val';
    kopf.appendChild(lbl);
    kopf.appendChild(val);
    gruppe.appendChild(kopf);

    var liste = document.createElement('div');
    liste.className = 'vk-sw__list';
    gruppe.appendChild(liste);

    var name = 'vk-sw-' + Math.random().toString(36).slice(2, 8);

    optionen.forEach(function (opt, i) {
      var label = opt.textContent.split('—')[0].trim();
      var aus = opt.disabled;
      var id = name + '-' + i;

      var item = document.createElement('div');
      item.className = 'vk-sw__item' + (aus ? ' vk-sw__item--out' : '');

      var input = document.createElement('input');
      input.type = 'radio';
      input.className = 'vk-sw__in';
      input.name = name;
      input.id = id;
      input.value = opt.value;
      input.disabled = aus;
      input.checked = opt.selected;

      var chip = document.createElement('label');
      chip.className = 'vk-sw__chip';
      chip.setAttribute('for', id);
      chip.style.setProperty('--vk-sw-bg', farben[i]);
      chip.title = label + (aus ? ' — ausverkauft' : '');
      /* Der Name steht im Label, nicht nur im title — sonst ist das Feld fuer
         Screenreader und fuer Leute mit Farbsehschwaeche nicht benennbar. */
      var sr = document.createElement('span');
      sr.className = 'vk-ct__vh';
      sr.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      sr.textContent = label + (aus ? ' (ausverkauft)' : '');
      chip.appendChild(sr);

      input.addEventListener('change', function () {
        if (!input.checked) return;
        select.value = opt.value;
        /* change auslösen, damit alles, was am <select> haengt, weiterlaeuft. */
        select.dispatchEvent(new Event('change', { bubbles: true }));
        val.textContent = label;
      });

      item.appendChild(input);
      item.appendChild(chip);
      liste.appendChild(item);
    });

    var gewaehlt = optionen[select.selectedIndex] || optionen[0];
    val.textContent = gewaehlt ? gewaehlt.textContent.split('—')[0].trim() : '';

    select.parentNode.insertBefore(gruppe, select);
    /* hidden blendet aus, deaktiviert aber nicht — der Wert wird weiterhin
       mitgeschickt. disabled waere hier falsch. */
    select.hidden = true;
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
  }

  function start() {
    document.querySelectorAll('select.vk-varsel').forEach(aufbauen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
